function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "remove1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 31 106 L 232 106 L 232 307 L 31 307 Z M 31 106 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "remove2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M -54.367188 206.320312 L 131.25 20.707031 L 316.867188 206.320312 L 131.25 391.9375 Z M -54.367188 206.320312 "
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "remove3"
}, /*#__PURE__*/React.createElement("path", {
  d: "M -54.367188 206.320312 L 131.25 20.707031 L 316.867188 206.320312 L 131.25 391.9375 Z M -54.367188 206.320312 "
})));

function SvgRemoveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "23px",
    viewBox: "0 0 262.5 337.500003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "removeicon"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#remove1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#remove2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#remove3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(86.669922%,23.139954%,39.99939%)",
      fillOpacity: 1
    },
    d: "M 189.253906 113.511719 L 131.25 171.519531 L 73.246094 113.511719 C 63.632812 103.902344 48.054688 103.902344 38.441406 113.511719 C 28.832031 123.125 28.832031 138.703125 38.441406 148.316406 L 96.445312 206.320312 L 38.441406 264.324219 C 28.832031 273.9375 28.832031 289.519531 38.441406 299.128906 C 48.054688 308.742188 63.632812 308.742188 73.246094 299.128906 L 131.25 241.125 L 189.253906 299.128906 C 198.867188 308.742188 214.445312 308.742188 224.058594 299.128906 C 233.667969 289.519531 233.667969 273.9375 224.058594 264.324219 L 166.054688 206.320312 L 224.058594 148.316406 C 233.667969 138.703125 233.667969 123.125 224.058594 113.511719 C 214.445312 103.902344 198.867188 103.902344 189.253906 113.511719 Z M 189.253906 113.511719 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/RemoveIcon.755de460.svg";
export { ForwardRef as ReactComponent };